import { getAuthSelfQueryOptions } from '@api/endpoints/auth/get-auth-self'
import { isAdmin } from '@core/utils/role-utils'
import Admin from '@platform/features/admin-settings'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/admin')({
  component: Admin,
  beforeLoad: async ({ context: { queryClient } }) => {
    const { roles } = await queryClient.ensureQueryData(
      getAuthSelfQueryOptions()
    )
    if (!isAdmin(roles)) throw redirect({ to: ROUTES.root })
  },
})
